import Marquee from "react-fast-marquee";

const WORDS = [
  "Visite a domicilio",
  "Medico in diretta",
  "TytoCare",
  "Infermiere qualificato",
  "Referto digitale",
  "Roma e provincia",
];

export default function BrandMarquee() {
  return (
    <section
      className="relative overflow-hidden bg-[#F1ECF8] py-8 sm:py-10 border-y border-[#5B2C91]/10"
      data-testid="brand-marquee"
      aria-hidden="true"
    >
      <Marquee speed={30} gradient gradientColor="#F1ECF8" gradientWidth={90} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-word px-8 text-5xl sm:text-7xl text-[#5B2C91]">
              {w}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-[#5B2C91]/40" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
